import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { LotSizing } from '@/types/core/lot-sizing/lot-sizing';

type LotSizingStatusBadgeProps = {
  purchaseOrders: LotSizing['purchaseOrders'];
};

export function LotSizingStatusBadge({
  purchaseOrders,
}: LotSizingStatusBadgeProps) {
  const { t } = useTranslation('lotSizings');
  const count = purchaseOrders?.length ?? 0;
  const isDraft = count === 0;

  if (isDraft) {
    return <Badge variant='gray'>{t('status draft')}</Badge>;
  }

  return (
    <Badge variant='green'>
      {t('status purchase order created with count', { count })}
    </Badge>
  );
}
